import ListPeopleGroups from './ListPeopleGroups';

export default ListPeopleGroups;
